export default __webpack_public_path__ + "static/24_36-43f232401f6ee122926d447ee5ba6c91.png";